/* eslint no-undef: 0 */
import * as utils from './utils'
import * as conf from '../env.config'

function removeUndefinedValues(props) {
  return Object.keys(props).reduce((acc, key) => {
    if (props[key] !== undefined && props[key] !== null && props[key] !== '') {
      acc[key] = props[key]
    }
    return acc
  }, {})
}

export const checkFromDev = (props) => {
  // check if not prod host
  if (!window.location.hostname.match(/discount-fares\.com$/)) {
    return 1
  }

  const regex = new RegExp(`@${utils.getForbidenStringDY()}|@${utils.getForbidenStringDT()}`, 'g')
  const contain = regex.test(props.email?.toLowerCase())
  const testersPhones = ['+16505578787', '+16509099090', '+16186190000']
  const isTestersPhone = testersPhones.includes(props.phone)

  return contain || isTestersPhone ? 1 : 0
}

function withDefaults(props = {}) {
  const finalProps = {
    ...conf.analyticsDefaults,

    sitephone: props.sitePhone,
    mfs: utils.firstValue(props.cookies?.mfs),

    project_name: props.project_name || conf.analyticsDefaults.project_name,
    page: props.url,
    page_type: props.pageType,
    from_dev: checkFromDev(props) || conf.analyticsDefaults.from_dev ? 1 : 0,
    trip_type: props.tripType,
    class: props.class || conf.analyticsDefaults.class,

    // departure_city: props.from,
    // destination_city: props.to,
    // departure_dt: props.departureDate,
    // destination_dt: props.arrivalDate,
    /// this gets mapped to props above by tas
    from: props.from,
    to: props.to,
    departure_date: props.departureDate,
    return_date: props.tripType === 'OW' ? null : props.arrivalDate,

    telephone: props.phone,
    email: props.email,
  }

  return removeUndefinedValues(finalProps)
}

function tasCallback(callback) {
  return (discount) => {
    if (typeof callback === 'function') {
      callback(discount)
    }
  }
}

export const tasInit = () => {
  if (window && !window.tas) {
    window['TravelAnalyticsObject'] = 'tas'
    const initTAS = (n, t, document, c) => {
      window['tas'].q = window['tas'].q || []
      window['tas'].q.push([n, t, document, c])
    }
    window[window['TravelAnalyticsObject']] = window['tas'] || initTAS
    let tas = document.createElement('script')
    tas.type = 'text/javascript'
    tas.async = true
    tas.src = conf.analyticsUrl + new Date().getTime() + '.js'
    const s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(tas, s)
  }
}

export const registerPageView = (props = {}, callback) => {
  tasInit()

  tas('put', 'discount', withDefaults(props), tasCallback(callback))
  setTimeout(() => tas('send', 'pageview'))
}

export const registerRequest = (props, callback) => {
  tasInit()

  tas('put', 'request', withDefaults(props), tasCallback(callback))
  tas('send', 'request')
}

export const registerIncompleteRequest = (props, callback) => {
  tasInit()

  tas('put', 'incomplete_request', withDefaults(props), tasCallback(callback))
  tas('send', 'incomplete_request')
}
